import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: Boolean,
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props





const icon = computed(() => {
  return props.modelValue ? 'inri-table-view' : 'inri-grid-view'
})

function toggleGridView () {
  emit('update:modelValue', !props.modelValue)
}

return (_ctx: any,_cache: any) => {
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!

  return (_openBlock(), _createBlock(_component_c_tile_btn, {
    "data-id": "toggle-grid-view-btn",
    icon: _unref(icon),
    "tooltip-left": __props.modelValue ? _ctx.$t('inri.toggle_actions.table_view') : _ctx.$t('inri.toggle_actions.grid_view'),
    onClick: toggleGridView
  }, null, 8, ["icon", "tooltip-left"]))
}
}

})